const LARGE_FACILITY_IMAGE_BASE_URL =
	"https://images.storage.com/large-compress";

export const buildLargeFacilityImageUrl = (image) =>
	`${LARGE_FACILITY_IMAGE_BASE_URL}/${image}`;
